import React from 'react';
import { team } from '../data/process';
export function FounderSection() {
  return <section id="ueber-uns" className="py-16 lg:py-28 bg-[#0d1225] scroll-mt-16" data-id="element-123" data-mp="2w9zrvyvzyupb">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-124" data-mp="3a9iyuod2o001">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-20" data-id="element-125" data-mp="3ab2dybmzs508">
          <figure className="lg:col-span-7" data-id="element-126" data-mp="367nypn6vnsnu">
            <blockquote className="text-2xl sm:text-3xl lg:text-4xl font-semibold text-white leading-snug" data-id="element-127" data-mp="366mdwr027rsx">
              „Anfang 2025 wollte ich die Agentur auch extrem skalieren. Aber
              dieser Service ist zu intensiv, um ihn komplett zu delegieren.
              Mein Ziel ist nicht, um jeden Preis zu wachsen – sondern dass
              unsere Kunden unser Marketing sind.“
            </blockquote>
            <figcaption className="mt-8 flex items-center gap-4" data-id="element-128" data-mp="3p0rkynhrn38f">
              <span className="w-12 h-12 rounded-full bg-[#ff6b35]/15 text-[#ff6b35] font-bold flex items-center justify-center" data-id="element-129" data-mp="6tbuefmu1yq7">
                JK
              </span>
              <span data-id="element-130" data-mp="29637lcw9lizi">
                <span className="block text-white font-semibold" data-id="element-131" data-mp="296la2r9istfv">Justus Kraft</span>
                <span className="block text-gray-400 text-sm" data-id="element-132" data-mp="2e5fshs3ksfzg">
                  Founder, CRM Kraft · weiterhin operativ involviert
                </span>
              </span>
            </figcaption>
          </figure>

          <div className="lg:col-span-5" data-id="element-133" data-mp="2o45cpriy2civ">
            <h2 className="text-xl font-semibold text-white mb-6" data-id="element-134" data-mp="2s45of4ens9m8">
              Über CRM Kraft – das Team hinter deinem Close CRM
            </h2>
            <ul className="divide-y divide-white/5 border-y border-white/5" data-id="element-135" data-mp="2x1xssxwhpo7b">
              {team.map(member => <li key={member.role} className="flex items-center gap-5 py-4" data-id="element-136" data-mp="31uqx5ko1quiv">
                  <span className="text-3xl font-bold text-[#ff6b35] w-8" data-id="element-137" data-mp="36rqth3v3giws">
                    {member.count}
                  </span>
                  <span className="text-gray-300" data-id="element-138" data-mp="3bqbtb26fp0kp">{member.role}</span>
                </li>)}
            </ul>
            <p className="mt-6 text-gray-400 leading-relaxed" data-id="element-139" data-mp="1goqjoqtmar8n">
              Wird es wirklich dringend, fixt Justus es selbst. Und weil wir
              nur so viele Kunden annehmen, wie wir perfekt betreuen können,
              sind die freien Plätze begrenzt – das ist kein Marketing-Gag.
            </p>
          </div>
        </div>
      </div>
    </section>;
}